/**
 * Created by lihanying on 2017/6/21.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { GETSCANSUCCESS } from './constants'
import { CLUB_ID } from '../ClubBusiness/constants'

export const getScanSuccess = (payload) => {
  return {
    type: GETSCANSUCCESS,
    payload,
  }
}

export function fetchScan(code, state) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/LoginApi/callBack`
    const myHeader = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        code: code,
        state: state,
      }),
    }
    fetch(endpoint, myHeader)
      .then((res) => res.json())
      .then((data) => {
        console.log('扫码后请求', data)
        if (data.status === true) {
          setTimeout(() => {
            dispatch(getScanSuccess(false))
            window.location.href = '/home/Homepage'
          }, 1500)
          sessionStorage.setItem('s', data.sessionId)
          sessionStorage.setItem('user_account', data.list.account)
          sessionStorage.setItem('club_name', data.list.club_name)
          sessionStorage.setItem(CLUB_ID, data.list.club_id)
          sessionStorage.setItem('role_id', data.list.role_id)
          sessionStorage.setItem('user_nickname', data.list.nickname)
          sessionStorage.setItem('headimgurl', data.list.headimgurl)
          sessionStorage.setItem('token', data.list.token)
        } else if (data.status === false) {
          setTimeout(() => {
            dispatch(getScanSuccess(false))
            window.location.href = '/binding'
          }, 1500)
          sessionStorage.setItem('s', data.sessionId)
          sessionStorage.setItem('shxt', data.shxt)
        } else {
          alert(data.detail)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/containers/WechatAuth/action.js